<template>
  <div>
    <Form ref="formInline" :model="current" :label-width="160" inline>
      <FormItem prop="describe" label="会员邀请赠送打印券:">
        <Select v-model="setting.share_cid" style="width:200px">
          <Option v-for="(v, k) in Coupon" :value="v.id" :key="k">{{ v.name }}</Option>
        </Select>
      </FormItem>

      <FormItem prop="describe" label="被邀请赠送打印券:">
        <Select v-model="setting.share_reg_cid" style="width:200px">
          <Option v-for="(v, k) in Coupon" :value="v.id" :key="k">{{ v.name }}</Option>
        </Select>
      </FormItem>

      <FormItem prop="describe" label="注册会员赠送打印券:">
        <Select v-model="setting.reg_cid" style="width:200px">
          <Option v-for="(v, k) in Coupon" :value="v.id" :key="k">{{ v.name }}</Option>
        </Select>
      </FormItem>

      <FormItem prop="describe" label="文档审核单价（厘）:">
        <InputNumber v-model="setting.file_check_price" :min="0" :max="10000" :step="1"></InputNumber>
      </FormItem>

      <FormItem prop="describe" label="驾驶舱虚标比例:">
        <InputNumber v-model="setting.dashboard_virtual" :min="0" :max="10000" :step="1"></InputNumber>
        <p>（例如：100表示0%虚标,150表示50%虚标）</p>
      </FormItem>
      <br/>
      <Button type="primary" @click="save">保存修改</Button>
    </Form>
    <div class="imgs">
      <!-- <div class="cropper-header">APP轮播图</div>
      <div class="imgBox">
        <div class="img" v-for="(item,key) in banner" :key="key">
          <img :src="item" alt>
          <span class="iconfont del" @click="BannerDel(key)">&#xe64b;</span>
        </div>
      </div>
      <Button class="addImg">
        添加轮播
        <input
          type="file"
          id="carousel"
          style="opacity: 0"
          ccept="image/png, image/jpeg, image/gif, image/jpg"
          @change="choose($event,1)"
        >
      </Button> -->
      <br />
      <Button @click="resetServer" type="primary">重置转换服务器计数</Button>
    </div>

    <div class="cropperWrap" v-if="cropper.preview">
      <div class="wrapbox">
        <VueCropper ref="cropper" :img="cropper.preview" :autoCropWidth="cropper.autoCropWidth"
          :autoCropHeight="cropper.autoCropHeight" :autoCrop="cropper.autoCrop" :fixedBox="cropper.fixedBox"
          :outputSize="cropper.outputSize / 100" :enlarge="cropper.enlarge"></VueCropper>
        <div class="control">
          <div style="width: 750px">
            图片质量:
            <Slider v-model="cropper.outputSize" :min="10" :step="10" :disabled="cropper.preview ? false : true"></Slider>
          </div>
          <Button type="warning" @click="$refs.cropper.rotateLeft()">左转</Button>
          <Button type="primary" @click="uploadImage">确定上传</Button>
          <Button type="warning" @click="$refs.cropper.rotateRight()">右转</Button>
          <Button type="error" @click="close">关闭</Button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { VueCropper } from 'vue-cropper'

export default {
  components: { VueCropper },
  data () {
    return {
      cropper: {
        visible: true,
        preview: '', // 预览 base64
        autoCrop: true,
        outputSize: 100, // 图片质量
        // 只有自动截图开启 宽度高度才生效
        autoCropWidth: 750,
        autoCropHeight: 580,
        fileType: '',
        fixedBox: true,
        enlarge: 2
      },
      banner: [],
      Coupon: [],
      setting: {
        share_cid: 0,
        share_reg_cid: 0,
        reg_cid: 0,
        file_check_price: 0
      },
      current: {}
    }
  },
  methods: {
    ...mapActions([
      'addBanner',
      'bannerList',
      'delBanner',
      'getCouponAll',
      'GetSetting',
      'SaveSetting',
      'ResetServer'
    ]),
    resetServer () {
      this.ResetServer().then(res => {
        this.$Message.success('重置成功')
      })
    },
    // 选择图片
    choose (e, type) {
      let file = e.target.files[0]
      if (file) {
        if (file.type !== 'image/jpeg' && file.type !== 'image/png') {
          this.$Message.error('仅支持图片文件')
          return
        }
        this.cropper.visible = true
        let temp = file.name.split('.')
        this.cropper.fileType = temp[temp.length - 1]
        var reader = new FileReader()
        reader.readAsDataURL(file)
        reader.onload = e => {
          console.log(e.currentTarget.result)
          this.cropper.preview = e.currentTarget.result
        }
      }
    },
    close () {
      this.cropper.preview = ''
    },
    uploadImage () {
      this.$refs.cropper.getCropBlob(data => {
        data.filename = 'a.jpg'
        console.log(data)
        if (data.size > 1024 * 1024) {
          this.$Modal.warning({
            title: '图片过大',
            content: '截图区域生成的文件过大,推荐挪动图片或降低图片质量'
          })
          return
        }

        let formData = new FormData()
        formData.append('file', data)
        this.addBanner(formData).then(res => {
          this.banner.push(res.url)
          this.$Message.success('设置成功')
          this.close()
        })
      })
    },
    getBanner () {
      this.bannerList().then(res => {
        this.banner = res.data
      })
    },
    BannerDel (key) {
      this.banner.splice(key, 1)
      let str = ''
      this.banner.map((item, index) => {
        str += item
        if (index < this.banner.length - 1) str += ','
      })
      this.delBanner({ url: str }).then(res => {
        this.$Message.success('删除成功')
      })
    },
    getData () {
      this.getCouponAll().then(res => {
        console.log(res)
        this.Coupon = res.data
      })
    },
    getSet () {
      this.GetSetting().then(res => {
        this.setting = res.data
      })
    },
    save () {
      this.SaveSetting(this.setting).then(res => {
        this.$Message.success('修改成功')
      })
    }
  },
  computed: mapGetters({}),
  mounted () {
    this.getBanner()
    this.getData()
    this.getSet()
  }
}
</script>

<style lang="less" scoped>
@import "./index.less";
</style>
